import { authFetch } from '~/services/fetch'

interface KeywordSearchLogsParams {
  readonly user_id?: number | null
  readonly station_id?: number | null
  readonly route?: string | null
  readonly start_date: string
  readonly finish_date: string
  readonly page?: number
  readonly limit?: number
  readonly orders?: readonly { readonly field: string; readonly sort: string }[]
}

export async function getKeywordSearchLogs(params: KeywordSearchLogsParams) {
  const { orders, ...otherParams } = params
  const response = await authFetch({
    url: '/logs/reports',
    method: 'POST',
    data: {
      ...otherParams,
      orders: orders || [{ field: 'created_at', sort: 'desc' }],
    },
  })

  return response.data
}
